import { Part, PartProduct } from '@entities/Product/module/types/productSchema';

export const getProductTypeText = (part: Part | PartProduct): string => {
  switch (part) {
    case Part.Tyres:
    case PartProduct.Tyres:
      return 'Шины';
    case Part.Disks:
    case PartProduct.Disks:
      return 'Диски';
    case Part.TruckTires:
    case PartProduct.TruckTires:
      return 'Грузовые шины';
    case Part.MotoTires:
    case PartProduct.MotoTires:
      return 'Мотошины';
    case Part.Batteries:
    case PartProduct.Batteries:
      return 'Аккумуляторы';
    case Part.RelatedProducts:
    case PartProduct.RelatedProducts:
      return 'Автотовары';
    case Part.Oils:
    case PartProduct.Oils:
      return 'Масло ';
    case Part.Secrets:
    case PartProduct.Secrets:
      return 'Секретки ';
    default:
      return '';
  }
};

export const getProductTypeUrl = (part: Part | PartProduct): string => {
  switch (part) {
    case Part.MotoTires:
    case Part.Tyres:
    case PartProduct.Tyres:
    case PartProduct.MotoTires:
      return '/catalog/tyres/';
    case Part.Disks:
    case PartProduct.Disks:
      return '/catalog/discs/';
    case Part.TruckTires:
    case PartProduct.TruckTires:
      return '/catalog/trucktyres/';
    case Part.Batteries:
    case PartProduct.Batteries:
      return '/catalog/accumulators/';
    case Part.Oils:
    case PartProduct.Oils:
      return '/catalog/oils/';
    case Part.RelatedProducts:
    case PartProduct.RelatedProducts:
      return '/catalog/autoparts/';
    case Part.Secrets:
    case PartProduct.Secrets:
      return '/catalog/locks/ ';
    default:
      return '';
  }
};

export const getProductTypeTextLowerCase = (part: Part | PartProduct): string => {
  return getProductTypeText(part).toLowerCase();
};
